import { ProviderPlugin } from './thirdPartyLoader';

const facebookPixelProvider = (
  additionalPixelIDs: string[] = [],
): ProviderPlugin => {
  return {
    initialize: () => {
      if (window.APP_DEBUG) {
        return;
      }
      delete window.fbq;
      // prettier-ignore
      /* eslint-disable */
      // @ts-ignore
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window,document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      /* eslint-enable */

      window.fbq('init', window.FACEBOOK_APP_ID);
      // Load additional Facebook Pixel ID's
      additionalPixelIDs.forEach(pixelID => {
        window.fbq('init', pixelID);
      });
      window.fbq('track', 'PageView');

      if (window.facebookQueue && window.facebookQueue.length) {
        window.facebookQueue.forEach(args => {
          window.fbq(...args);
        });
      }
    },
    loaded: () => {
      return !!window.fbq;
    },
  };
};

export default facebookPixelProvider;
